import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDate } from '@/utils/dateFormat';
import { History } from 'lucide-react';
import { varianceClass } from './AuditLinesTable';

// Immutable count log (newest first) — what the manager / HQ monitor live.
export const AuditEntriesLog = ({ entries }) => (
  <Card data-testid="audit-entries-log">
    <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><History className="w-4 h-4 text-indigo-600" /> Count log <span className="text-xs text-gray-400 font-normal">({entries.length} entries, newest first)</span></CardTitle></CardHeader>
    <CardContent className="p-0 overflow-x-auto max-h-[420px] overflow-y-auto">
      <table className="w-full text-xs">
        <thead className="bg-gray-50 text-gray-600 text-left sticky top-0"><tr><th className="p-2">Time</th><th className="p-2">Product</th><th className="p-2 text-right">System</th><th className="p-2 text-right">Counted</th><th className="p-2 text-right">Variance</th><th className="p-2">Reason</th><th className="p-2">By</th><th className="p-2">Device</th></tr></thead>
        <tbody>
          {entries.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-gray-400">No counts yet.</td></tr>}
          {entries.map(e => (
            <tr key={e.id} className="border-t" data-testid={`audit-entry-${e.id}`}>
              <td className="p-2 whitespace-nowrap">{formatDate(e.at)}</td>
              <td className="p-2"><div className="font-medium">{e.product_name}</div><div className="text-[10px] text-gray-400">{e.sku}{e.is_recount ? ' · recount' : ''}{e.previous_qty !== null && e.previous_qty !== undefined ? ` (was ${e.previous_qty})` : ''}</div></td>
              <td className="p-2 text-right font-mono">{e.system_qty}</td>
              <td className="p-2 text-right font-mono">{e.physical_qty ?? '—'}</td>
              <td className={`p-2 text-right font-mono font-semibold ${varianceClass(e.variance)}`}>{e.variance === null || e.variance === undefined ? '—' : e.variance > 0 ? `+${e.variance}` : e.variance}</td>
              <td className="p-2">{e.reason || ''}{e.remarks ? <div className="text-[10px] text-gray-400">{e.remarks}</div> : null}</td>
              <td className="p-2">{e.by_name}<div className={`text-[10px] ${e.source === 'internal_post' ? 'text-emerald-700 font-medium' : 'text-gray-400'}`}>{e.source === 'pin_link' ? 'PIN link' : e.source === 'internal_post' ? 'Internal stock post' : 'app'}</div></td>
              <td className="p-2 font-mono text-[10px] text-gray-500">{e.device_id ? `${e.device_id.slice(0, 12)}…` : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </CardContent>
  </Card>
);

export default AuditEntriesLog;
